import React, { HTMLAttributes, useState } from 'react'
import { css } from '@emotion/core'
import { LoadingContent } from '../molecules/loading-content'

interface Props extends HTMLAttributes<HTMLIFrameElement> {
  src: string
  // link-text: 単純なテキストリンク
  // button: ボタンスタイルのリンク
  type?: 'link-text' | 'button'
}

const imageUrlPattern = /\.(avif|bmp|gif|ico|jpe?g|png|svg|webp)(\?.*)?(#.*)?$/i

const isImageUrl = (url: string): boolean => imageUrlPattern.test(url)

export const ExternalLinkModal: React.FC<Props> = ({ src, children, type = 'link-text', ...optionalProps }) => {
  const [showModal, setShowModal] = useState(false)
  const [isExternalLinkLoadCompleted, setIsExternalLinkLoadCompleted] = useState(false)
  const isImageContent = isImageUrl(src)

  const onOpenModal = () => {
    setIsExternalLinkLoadCompleted(false)
    setShowModal(true)
  }

  const onCloseModal = () => {
    setShowModal(false)
  }

  return (
    <div css={componentStyle}>
      <div className={type} onClick={onOpenModal}>
        {children}
      </div>
      {showModal && (
        <div className="modal-overlay">
          <div className="external-link-modal">
            <LoadingContent isLoading={!isExternalLinkLoadCompleted} />
            <div className="modal-close-block">
              <img src={require('@/static/images/delete_orange.svg')} width={30} onClick={onCloseModal} />
            </div>
            {isImageContent ? (
              <div className="image-wrapper">
                <img
                  src={src}
                  alt={src}
                  onLoad={() => setIsExternalLinkLoadCompleted(true)}
                  onError={() => setIsExternalLinkLoadCompleted(true)}
                />
              </div>
            ) : (
              <iframe src={src} title={src} {...optionalProps} onLoad={() => setIsExternalLinkLoadCompleted(true)}></iframe>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

const componentStyle = css({
  display: 'inline',
  '.link-text': {
    cursor: 'pointer',
    color: '#f2a40b',
    display: 'inline',
  },
  '.button': {
    cursor: 'pointer',
    background: '#A59785',
    color: '#FFFFFF',
    borderRadius: 6,
    height: 54,
    display: 'block',
    textAlign: 'center',
    lineHeight: '54px',
    margin: '32px 0',
    fontSize: 18,
    letterSpacing: '1.6px',
    textDecoration: 'none',
    ':hover,:active': {
      color: '#FFFFFF',
    },
  },
  '.modal-overlay': {
    position: 'fixed',
    inset: 0,
    background: 'rgba(39, 39, 39, 0.5)',
    zIndex: 1000,
    padding: 48,
  },
  '.external-link-modal': {
    position: 'relative',
    background: '#f2f2f2',
    borderRadius: 5,
    width: '100%',
    height: '100%',
    '.image-wrapper': {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#FFFFFF',
      img: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
      },
    },
    iframe: {
      width: '100%',
      height: '100%',
    },
    '.modal-close-block': {
      position: 'absolute',
      zIndex: 1000,
      right: 12,
      top: 12,
      '>img': {
        cursor: 'pointer',
        boxShadow: '0px 3px 10px #0000003d',
        borderRadius: '100%;',
        background: '#fff',
      },
    },
  },
})
